/**
 * The headline numbers for one budget option: what the client pays (paid
 * media), what it buys, the added value on top, and the total delivered.
 */

import React from 'react';
import { KpiCard } from '../../ui';
import type { MediaPlanRequest, MediaPlanTier } from './types';
import { groupsFor } from './PlanLinesTable';
import { fmtBudget, fmtInt, fmtUsd } from './formStyles';

interface Props {
  tier: MediaPlanTier;
  request: MediaPlanRequest;
}

const PlanTotals: React.FC<Props> = ({ tier, request }) => {
  const t = tier.totals;
  const audiences = groupsFor(tier, request).length;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: 12 }}>
      <KpiCard label="Paid media" value={fmtUsd(t.paidCostUsd)} featured hint={`${fmtBudget(tier.budgetUsd)} option · ${audiences} audience${audiences === 1 ? '' : 's'}`} />
      <KpiCard label="Paid impressions" value={fmtInt(t.paidImpressions)} />
      <KpiCard label="Added value" value={fmtInt(t.addedValueImpressions)} hint={t.addedValueValueUsd > 0 ? `${fmtUsd(t.addedValueValueUsd, 0)} value, no charge` : t.addedValueImpressions > 0 ? 'impressions, no charge' : 'none'} />
      <KpiCard label="Total incl. added value" value={fmtInt(t.totalImpressions)} hint="impressions" />
      <KpiCard label="Blended CPM" value={fmtUsd(t.blendedCpm)} hint="paid CPM lines, net" />
    </div>
  );
};

export default PlanTotals;
